module.exports = __webpack_public_path__ + "img/wxqcode.00ce8a67.jpg";